import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {GlossaryDataset, GlossaryTerm} from "../../actions/api";
import { fetchGlossary as apiFetchGlossary} from "../../actions/api";
import { fetchGlossaryDatasets as apiFetchDatasets } from "../../actions/api";
import {RootState} from "../../configureStore";

export type TermsGroup = {
    key: string,
    terms: GlossaryTerm[]
}

export type GlossaryData = Array<TermsGroup>

interface GlossaryState {
    glossary: GlossaryTerm[] | undefined
    datasets: GlossaryDataset[] | undefined
}

const initialState: GlossaryState = {
    glossary: undefined,
    datasets: undefined
}

export const groupGlossary = (terms: GlossaryTerm[] | undefined): GlossaryData | undefined => {
    if (terms === undefined) {
        return undefined
    }

    return Object.entries(terms.reduce((glossary, term) => {
        let key = term.title.charAt(0).toUpperCase()
        key = key.match("[A-Z]{1}") ? key : '#123'
        const terms = glossary[key] ?? []
        return {
            ...glossary,
            [key]: terms.concat(term)
        }
    }, {} as Record<string, GlossaryTerm[]>))
        .map(([key, terms])=> {
        return {
            key,
            terms: terms.sort((a, b) => a.title.localeCompare(b.title))
        }
    }).sort((a, b) => a.key.localeCompare(b.key))
}

export const fetchGlossary = createAsyncThunk(
    'glossary/fetchGlossary',
    async () => {
        return apiFetchGlossary()
    }
)

export const fetchDatasets = createAsyncThunk(
    'glossary/fetchDataSets',
    async () => {
        return apiFetchDatasets()
    }
)


export const glossarySlice = createSlice({
    name: 'glossary',
    initialState,
    reducers: {
        clearGlossary: (state) => {
            state.glossary = undefined
        }
    },
    extraReducers: builder => {
        builder.addCase(fetchGlossary.pending, (state) => {
            state.glossary = undefined
        })
        builder.addCase(fetchGlossary.fulfilled, (state, action) => {
            state.glossary = action.payload
        })
        builder.addCase(fetchDatasets.fulfilled, (state, action) => {
            state.datasets = action.payload.sort((a,b) => a.title.localeCompare(b.title))
        })
    }
})

export const { clearGlossary } = glossarySlice.actions
export const selectGlossary = (state: RootState) => state.glossary.glossary

export const selectDatasets = (state: RootState) => state.glossary.datasets
export default glossarySlice.reducer